import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sold-out',
  templateUrl: './sold-out.component.html',
  styleUrls: ['./sold-out.component.scss']
})
export class SoldOutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
